import _ from "lodash"

const ones = [
  "",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
]
const teens = [
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
]
const tens = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety",
]
const thousands = ["", "thousand", "million", "billion", "trillion"]

function readHundreds(num) {
  let str = ""
  const hundred = Math.floor(num / 100)
  const rest = num % 100
  if (hundred > 0) {
    str += ones[hundred] + " hundred"
    if (rest > 0) str += " "
  }
  if (rest >= 10 && rest < 20) {
    str += teens[rest - 10]
  } else {
    const ten = Math.floor(rest / 10)
    const one = rest % 10
    if (ten > 0) str += tens[ten]
    if (ten > 0 && one > 0) str += "-"
    if (one > 0) str += ones[one]
  }
  return str
}

export default function moneyToStringUS(num) {
  if (num === 0) return "zero dollars"
  let str = ""
  let i = 0
  while (num > 0) {
    const chunk = num % 1000
    if (chunk > 0) {
      const chunkStr = readHundreds(chunk)
      str =
        chunkStr + (chunkStr ? " " : "") + thousands[i] + (str ? " " : "") + str
    }
    num = Math.floor(num / 1000)
    i++
  }
  str = str.trim()
  if (!str.endsWith("dollars")) str += " dollars"
  return _.capitalize(str)
}
